<template>
  <div class="box p-5">
    <div class="table-regular">
      <div class="table-regular-holder">
        <table class="table">
          <thead>
            <tr>
              <th v-if="lineNumbers">
                <div class="table-regular-col-title">
                  {{ $t('table.number') }}
                </div>
              </th>
              <template v-for="(column, columnIndex) in columns">
                <th v-if="!column.disabled" :key="`column-${columnIndex}`">
                  <div class="table-regular-col-title">
                    {{ column.label }}
                  </div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr>
                <td :colspan="lineNumbers ? columns.length + 1 : columns.length">
                  <div class="flex items-center justify-center">
                    <LoadingIcon icon="oval" class="w-5 h-5" />
                    <p class="text-gray-500 ml-3">{{ $t('table.loading') }}</p>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else-if="rows.length < 1">
              <tr>
                <td :colspan="lineNumbers ? columns.length + 1 : columns.length">
                  <div class="flex items-center justify-center">
                    <InboxIcon class="w-5 h-5 text-gray-500" />
                    <p class="text-gray-500 ml-3">{{ $t('table.noItems') }}</p>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                <td v-if="lineNumbers">{{ rowIndex + 1 }}</td>
                <template v-for="(column, columnIndex) in columns">
                  <td
                    v-if="!column.disabled"
                    :key="columnIndex"
                    :class="{ 'table-report__action w-56': column.field === 'action' }"
                  >
                    <slot name="table-row" :column="column" :row="row">
                      {{ row[column.field] }}
                    </slot>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>

          <tfoot>
            <slot name="footer"></slot>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import tableMixin from '@/mixins/tableMixin';

export default {
  mixins: [tableMixin],
};
</script>
